import moment from "moment";
import { Grid } from "@material-ui/core";
import React, { PureComponent } from "react";

class WorkScheduleReportWeekPreview extends PureComponent {
  render() {
    const { date, renderPreviewDay } = this.props;

    const days = Array.from(
      moment
        .range(date.clone().startOf("isoWeek"), date.clone().endOf("isoWeek"))
        .by("day"),
    );

    return (
      <Grid item container xs wrap="nowrap">
        {days.map(renderPreviewDay)}
      </Grid>
    );
  }
}

export default WorkScheduleReportWeekPreview;
